'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Card = require('./Card');

var _Card2 = _interopRequireDefault(_Card);

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _Bar = require('./Bar');

var _Bar2 = _interopRequireDefault(_Bar);

var _Pie = require('./Pie');

var _Pie2 = _interopRequireDefault(_Pie);

var _Radar = require('./Radar');

var _Radar2 = _interopRequireDefault(_Radar);

var _Funnel = require('./Funnel');

var _Funnel2 = _interopRequireDefault(_Funnel);

var _MiniLine = require('./MiniLine');

var _MiniLine2 = _interopRequireDefault(_MiniLine);

var _MiniBar = require('./MiniBar');

var _MiniBar2 = _interopRequireDefault(_MiniBar);

var _Trend = require('./Trend');

var _Trend2 = _interopRequireDefault(_Trend);

var _Define = require('./Define');

var _Define2 = _interopRequireDefault(_Define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartComponent = function (_Component) {
  (0, _inherits3.default)(ChartComponent, _Component);

  function ChartComponent(props) {
    (0, _classCallCheck3.default)(this, ChartComponent);
    return (0, _possibleConstructorReturn3.default)(this, (ChartComponent.__proto__ || (0, _getPrototypeOf2.default)(ChartComponent)).call(this, props));
  }

  (0, _createClass3.default)(ChartComponent, [{
    key: 'renderChildren',
    value: function renderChildren() {
      return _react2.default.Children.map(this.props.children, function (child) {
        return (0, _react.cloneElement)(child, child.props);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChildren()
      );
    }
  }]);
  return ChartComponent;
}(_react.Component);

ChartComponent.Card = _Card2.default;
ChartComponent.Line = _Line2.default;
ChartComponent.Bar = _Bar2.default;
ChartComponent.Pie = _Pie2.default;
ChartComponent.Radar = _Radar2.default;
ChartComponent.Funnel = _Funnel2.default;
ChartComponent.MiniLine = _MiniLine2.default;
ChartComponent.MiniBar = _MiniBar2.default;
ChartComponent.Trend = _Trend2.default;
ChartComponent.Define = _Define2.default;

exports.default = ChartComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Chart.js
// module id = 600
// module chunks = 0